<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']">
          <i class="fa fa-truck"></i>
          Lieferscheine
        </a>
      </li>
      @if (deliveryNote) {
        <li>
          <a [routerLink]="['/', 'lieferscheine', deliveryNote.id]">{{ deliveryNote?.number }}</a>
        </li>
        @if (deliveryNote.shipcloud_retoure_carrier && deliveryNote.related_note_id) {
          <li>
            Retoure:
            <a href="/unknown-for-now">
              {{ deliveryNote.related_note_number }}
            </a>
          </li>
        }
      }
      <li>
        <a>Label über Shipcloud erstellen</a>
      </li>
    </ul>
  </div>
</div>

@if (deliveryNote) {
  <div class="page-content page-frame overflow-auto">
    <form
      class="page-sheet max-w-4xl mx-auto grid grid-cols-2 grid-flow-dense grid-rows-[auto_1fr]"
      [formGroup]="deliveryNoteShippingForm"
      (submit)="createShipping()"
    >
      <section class="bm-card bm-card-sm">
        <div class="bm-card-body">
          <h2 class="bm-card-title">Empfänger</h2>
          <table class="bm-table bm-table-xs">
            <tr>
              <th>Firma</th>
              <td>{{ deliveryNote.recipient_address_company || "-" }}</td>
            </tr>
            <tr>
              <th>Name</th>
              <td>
                {{ deliveryNote.recipient_address_firstname }}
                {{ deliveryNote.recipient_address_lastname }}
              </td>
            </tr>
            <tr>
              <th>Straße</th>
              <td>{{ deliveryNote.recipient_address_street || "-" }}</td>
            </tr>
            <tr>
              <th>PLZ/Ort</th>
              <td>
                {{ deliveryNote.recipient_address_zip }}
                {{ deliveryNote.recipient_address_city }}
              </td>
            </tr>
            <tr>
              <th>Land</th>
              <td>
                {{ deliveryNote.recipient_address_country }}
                <span *ngIf="deliveryNote.recipient_address_state"> ({{ deliveryNote.recipient_address_state }}) </span>
              </td>
            </tr>
          </table>
        </div>
      </section>

      <section class="bm-card bm-card-sm">
        <fieldset class="bm-card-body">
          <h2 class="bm-card-title">Paket</h2>
          <label class="bm-input w-full">
            <span class="bm-label w-32">Höhe</span>
            <input type="number" [formControl]="deliveryNoteShippingForm.controls.height" required />
            <span>cm</span>
          </label>
          <label class="bm-input w-full">
            <label class="bm-label w-32">Breite</label>
            <input type="number" [formControl]="deliveryNoteShippingForm.controls.width" required />
            <span>cm</span>
          </label>
          <label class="bm-input w-full">
            <label class="bm-label w-32">Länge</label>
            <input type="number" [formControl]="deliveryNoteShippingForm.controls.length" required />
            <span>cm</span>
          </label>
          <label class="bm-input w-full">
            <label class="bm-label w-32">Gewicht</label>
            <input type="number" [formControl]="deliveryNoteShippingForm.controls.weight" required />
            <span>kg</span>
          </label>
        </fieldset>
      </section>

      <section class="bm-card bm-card-sm col-span-2">
        <fieldset class="bm-card-body">
          <h2 class="bm-card-title">Versand</h2>

          <div class="grid grid-cols-2 gap-8">
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">Carrier</label>
              <ng-select
                [items]="carriersList"
                [formControl]="deliveryNoteShippingForm.controls.carrier"
                [required]="true"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
                  @if (item.toLowerCase().includes(searchTerm.toLowerCase())) {
                    {{ item }}
                  }
                </ng-template>
              </ng-select>

              <label class="bm-fieldset-label">Service</label>
              <ng-select
                [items]="shippingServices"
                [formControl]="deliveryNoteShippingForm.controls.service"
                bindLabel="name"
                bindValue="id"
                required
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.name }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
                  @if (item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                    {{ item.name }}
                  }
                </ng-template>
              </ng-select>

              <label class="bm-fieldset-label"> Preis </label>
              <div class="bm-join w-full">
                <div class="bm-join-item bm-input bm-input-disabled w-full" id="price_element"></div>
                <button
                  [disabled]="deliveryNoteShippingForm.invalid || loadingPricing"
                  type="button"
                  class="bm-join-item bm-btn"
                  (click)="calculatePrirce()"
                >
                  <i class="fa fa-refresh" aria-hidden="true"></i>Preis ermitteln
                </button>
              </div>

              <label class="bm-fieldset-label">Telefonnummer Sender (Express)</label>
              <input
                type="text"
                class="bm-input w-full"
                [formControl]="deliveryNoteShippingForm.controls.sender_phone"
              />

              <label class="bm-fieldset-label">Telefonnummer Empfänger (Express)</label>
              <input
                type="text"
                class="bm-input w-full"
                [formControl]="deliveryNoteShippingForm.controls.receiver_phone"
              />
            </fieldset>

            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">Benachrichtigung</label>
              <input type="email" class="bm-input w-full" [formControl]="deliveryNoteShippingForm.controls.email" />

              <label class="bm-fieldset-label">Paketbeschreibung</label>
              <textarea
                class="bm-textarea w-full"
                [formControl]="deliveryNoteShippingForm.controls.description"
              ></textarea>
              <span>Bei DHL-Express erforderlich, Preisauskunft aber nicht möglich</span>

              <label class="bm-fieldset-label">
                Pickup (Direktbuchung):
                <input
                  class="bm-checkbox"
                  type="checkbox"
                  [formControl]="deliveryNoteShippingForm.controls.direct_pickup"
                />
                Abholung direkt buchen (DHL Express)
              </label>

              <div class="bm-join">
                <input
                  class="w-full bm-input bm-join-item"
                  [formControl]="deliveryNoteShippingForm.controls.pickup_day"
                  [matDatepicker]="picker"
                  placeholder="MM/DD/YYYY"
                />
                <mat-datepicker #picker />
                <button class="bm-btn bm-join-item" (click)="picker.opened ? picker.close() : picker.open(); (false)">
                  <span class="fa fa-calendar"></span>
                </button>
              </div>

              <div class="flex flex-row gap-2 items-center">
                <input
                  class="bm-input w-full"
                  type="time"
                  [formControl]="deliveryNoteShippingForm.controls.pickup_start"
                />

                <label for="pickup_end" class="col-sm-1 control-label pl-0 pr-0" style="text-align: center">
                  <i class="fa fa-long-arrow-right" aria-hidden="true"> </i>
                </label>
                <input
                  class="bm-input w-full"
                  type="time"
                  [formControl]="deliveryNoteShippingForm.controls.pickup_end"
                />
              </div>

              <label class="bm-fieldset-label">
                Sonderwünsche:
                <input
                  class="bm-checkbox"
                  type="checkbox"
                  [formControl]="deliveryNoteShippingForm.controls.saturday_delivery"
                />
                Samstagszustellung (DHL Express)
              </label>
            </fieldset>
          </div>
        </fieldset>
      </section>

      <div class="flex flex-row gap-2 items-center justify-end col-span-3">
        <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', deliveryNote.id]">Abbrechen</a>
        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [formControl]="deliveryNoteShippingForm.controls.test" />Nur Test
        </label>
        <button
          class="bm-btn bm-btn-primary"
          [disabled]="deliveryNoteShippingForm.invalid || submittingLabel"
          type="submit"
        >
          Versandmarke erstellen und drucken
        </button>
      </div>
    </form>
  </div>
}
